/*
 * PHONE COUNTRY LIST AS A SHEET — swipe down to close (intl-tel-input v17, phones).
 *
 * On a phone the library opens its country list in an `.iti--container` on the <body> (`body.iti-mobile`; the
 * theme styles it as a sheet). This adds the gesture: dragging down from the handle (the top 44px) or from the
 * top of the list moves the sheet with the finger; past a quarter of its height, or on a quick flick (0.5 px/ms),
 * it slides down and the library closes it with its own "click outside" handler (`document.documentElement`
 * click); otherwise it springs back. The listeners sit only on the open sheet (bound when the container is
 * created), so the list's scrolling is not slowed.
 */
(() => {
    const EASE = 'cubic-bezier(.32, .72, 0, 1)';
    const HANDLE = 44;

    const bind = (c) => {
        if (c.dataset.vvDrag) return;
        c.dataset.vvDrag = '1';
        let d = null;
        c.addEventListener('touchstart', (e) => {
            if (e.touches.length !== 1) return;
            const y = e.touches[0].clientY;
            d = {
                y0: y,
                t0: performance.now(),
                onHandle: y - c.getBoundingClientRect().top < HANDLE,
                list: c.querySelector('.iti__country-list'),
                moved: false,
                dy: 0,
                last: [performance.now(), y],
            };
        }, { passive: true });
        c.addEventListener('touchmove', (e) => {
            if (!d) return;
            const y = e.touches[0].clientY;
            const dy = y - d.y0;
            if (!d.moved) {
                if (Math.abs(dy) < 6) return;
                const atTop = !d.list || d.list.scrollTop <= 0;
                if (!(dy > 0 && (d.onHandle || atTop))) { d = null; return; }
                d.moved = true;
                d.y0 = y;
                c.style.animation = 'none';
                c.style.transition = 'none';
            }
            d.dy = Math.max(0, y - d.y0);
            d.v = (y - d.last[1]) / Math.max(1, performance.now() - d.last[0]);
            d.last = [performance.now(), y];
            c.style.transform = 'translateY(' + d.dy + 'px)';
            if (e.cancelable) e.preventDefault();
        }, { passive: false });
        const end = () => {
            const s = d;
            d = null;
            if (!s || !s.moved) return;
            c.style.transition = 'transform .28s ' + EASE;
            if (s.dy > c.offsetHeight * 0.25 || (s.v || 0) > 0.5) {
                c.style.transform = 'translateY(100%)';
                setTimeout(() => {
                    document.documentElement.click();
                    c.dataset.vvShown = '';
                    setTimeout(() => reset(c), 50);
                }, 260);
            } else {
                c.style.transform = '';
            }
        };
        c.addEventListener('touchend', end, { passive: true });
        c.addEventListener('touchcancel', end, { passive: true });
    };

    /* the library puts the same box back on reopening: the slid-down state (translateY(100%)) must not stay on it,
       or the sheet would open invisibly */
    const reset = (c) => {
        c.style.transform = '';
        c.style.transition = '';
        c.style.animation = '';
    };
    const scan = () => {
        const c = document.querySelector('body.iti-mobile > .iti--container');
        if (c) { if (c.dataset.vvShown !== '1') reset(c); c.dataset.vvShown = '1'; bind(c); }
        document.querySelectorAll('.iti--container[data-vv-shown="1"]').forEach((x) => { if (!x.isConnected || x !== c) x.dataset.vvShown = ''; });
    };
    const start = () => {
        new MutationObserver(scan).observe(document.body, { childList: true });
        scan();
    };
    if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();
